import { createAuthFetcher, CONTRACTOR_AUDIENCE } from './auth-fetch'
import { beginAppRequest } from './app-processing'
const accountFetcher = createAuthFetcher(CONTRACTOR_AUDIENCE)

export async function api<T>(path: string, options?: RequestInit): Promise<T> {
  const finish = path.endsWith('/processing') ? () => {} : beginAppRequest()
  try { return await accountFetcher.api<T>(path, options) } finally { finish() }
}
export async function fetchWithAuth(path: string, options?: RequestInit): Promise<Response> {
  const finish = beginAppRequest()
  try {
    const response = await accountFetcher.fetchWithAuth(path, options)
    if (!response.body || !response.headers.get('content-type')?.includes('text/event-stream')) {
      finish()
      return response
    }
    const reader = response.body.getReader()
    const body = new ReadableStream<Uint8Array>({
      async pull(controller) {
        try {
          const chunk = await reader.read()
          if (chunk.done) { finish(); controller.close() }
          else controller.enqueue(chunk.value)
        } catch (error) { finish(); controller.error(error) }
      },
      async cancel(reason) { finish(); await reader.cancel(reason) },
    })
    return new Response(body, { status: response.status, statusText: response.statusText, headers: response.headers })
  } catch (error) { finish(); throw error }
}
